/* mt-ui: wishlist/compare toggles, quick add to cart, product rails */
(function () {
  if (window.mtUI) return; window.mtUI = true;

  function read(k) { try { return JSON.parse(localStorage.getItem('mt_' + k) || '[]'); } catch (e) { return []; } }
  function mark() {
    document.querySelectorAll('[data-mt-toggle]').forEach(function (b) {
      b.classList.toggle('is-on', read(b.dataset.mtToggle).indexOf(b.dataset.handle) > -1);
    });
  }
  window.mtToggleBound = true;
  window.mtMark = mark;

  function root() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }

  function addToCart(btn) {
    var id = btn.dataset.mtAdd, label = btn.querySelector('span'), old = label ? label.textContent : '';
    btn.classList.add('is-busy');
    fetch(root() + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: +id, quantity: 1 }] }) })
      .then(function (r) { if (!r.ok) throw r; return fetch(root() + 'cart.js'); })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        btn.classList.remove('is-busy'); btn.classList.add('is-done');
        if (label) label.textContent = 'נוסף לסל ✓';
        document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart, sourceId: 'mt-card', data: { source: 'mt-card', itemCount: cart.item_count } } }));
        setTimeout(function () { btn.classList.remove('is-done'); if (label) label.textContent = old; }, 2200);
      })
      .catch(function () {
        btn.classList.remove('is-busy');
        if (label) { label.textContent = 'לא נוסף, נסו שוב'; setTimeout(function () { label.textContent = old; }, 2200); }
      });
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-mt-toggle]');
    if (t) {
      e.preventDefault();
      var k = t.dataset.mtToggle, list = read(k), i = list.indexOf(t.dataset.handle);
      if (i > -1) list.splice(i, 1); else { if (k === 'compare' && list.length >= 4) list.shift(); list.push(t.dataset.handle); }
      try { localStorage.setItem('mt_' + k, JSON.stringify(list)); } catch (err) {}
      mark(); document.dispatchEvent(new CustomEvent('mt:saved'));
      return;
    }
    var a = e.target.closest('[data-mt-add]');
    if (a) { e.preventDefault(); addToCart(a); return; }
    var n = e.target.closest('[data-mt-nav]');
    if (n) {
      var rail = document.getElementById(n.getAttribute('aria-controls'));
      if (!rail) return;
      var dir = getComputedStyle(rail).direction === 'rtl' ? -1 : 1;
      var step = rail.clientWidth * 0.9 * (n.dataset.mtNav === 'next' ? 1 : -1) * dir;
      rail.scrollBy({ left: step, behavior: 'smooth' });
    }
  });

  function init() { mark(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
